export default "__VITE_ASSET__o54E3xiC__"